import React, { useState, useEffect } from "react";
import { Table, Modal } from "react-bootstrap";
import {
  getTurnos,
  deleteTurno,
  getTurnoById,
} from "../helpers/rutaTurnos";
import ModalFormTurno from "./ModalFormTurno";

/* =========================================================
   ANCHOS DE COLUMNAS
   Tocá estos valores a gusto
========================================================= */
const COLS = {
  acciones: 90,
  nro: 50,
  fecha: 120,
  persona: 180,
  atencion: 140,
  nombre: 200,
  telefono: 100,
  observacion: 400,
};

const cellTruncate = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
};

const formatFecha = (value) => {
  if (!value) return "-";

  if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
    const [y, m, d] = value.split("-");
    return `${d}/${m}/${y}`;
  }

  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "-";

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yy = d.getFullYear();

  return `${dd}/${mm}/${yy}`;
};

const atencionDesc = (v) => {
  switch (Number(v)) {
    case 0:
      return "SIN DEFINIR";
    case 1:
      return "EN ESPERA";
    case 2:
      return "ATENDIDO";
    case 3:
      return "RECHAZADO";
    default:
      return "-";
  }
};

const getPersonaDesc = (p) => {
  if (!p) return "-";

  if (typeof p === "object") {
    const cod = p?.codper ?? "";
    const nombre = p?.nombre ?? "";
    return cod !== "" ? `${cod} - ${nombre}` : nombre || "-";
  }

  return String(p);
};

const TableTurnos = () => {
  const [state, setState] = useState({
    turnos: [],
    loading: true,
    error: "",
  });

  const [turno, setTurno] = useState({});
  const [show, setShow] = useState(false);

  useEffect(() => {
    consultaTurnos();
  }, []);

  const consultaTurnos = async () => {
    try {
      const datos = await getTurnos();
      const lista = Array.isArray(datos)
        ? datos
        : Array.isArray(datos?.turnos)
        ? datos.turnos
        : [];

      setState({
        turnos: lista,
        loading: false,
        error: "",
      });
    } catch (e) {
      setState((s) => ({
        ...s,
        loading: false,
        error: e?.message || "Error al cargar turnos",
      }));
      console.error("❌ Error getTurnos:", e);
    }
  };

  const handleClose = () => {
    setShow(false);
    consultaTurnos();
  };

  const handleShow = () => setShow(true);

  const modificaTurno = (id) => {
    getTurnoById(id)
      .then((resp) => {
        setTurno(resp?.turno ?? resp);
        handleShow();
      })
      .catch((err) => console.error("❌ Error getTurnoById:", err));
  };

  const eliminarTurno = (id) => {
    if (window.confirm("¿Está seguro que desea borrar el turno?")) {
      deleteTurno(id)
        .then(() => consultaTurnos())
        .catch((err) => console.error("❌ Error deleteTurno:", err));
    }
  };

  if (state.loading) return <div className="p-3">Cargando turnos…</div>;
  if (state.error) return <div className="p-3 text-danger">{state.error}</div>;

  const rows = state.turnos.filter((t) => t?.activo ?? true);

  return (
    <div className="table-container">
      <div className="col-12 mt-4" />

      <div>
        <Table
          striped
          bordered
          hover
          style={{ tableLayout: "fixed", width: "100%" }}
        >
          <thead>
            <tr>
              <th style={{ width: COLS.acciones }}>Acciones</th>
              <th style={{ width: COLS.nro }}>Nro</th>
              <th style={{ width: COLS.fecha }}>Fecha</th>
              <th style={{ width: COLS.persona }}>Persona</th>
              <th style={{ width: COLS.atencion }}>Atención</th>
              <th style={{ width: COLS.nombre }}>Nombre</th>
              <th style={{ width: COLS.telefono }}>Teléfono</th>
              <th style={{ width: COLS.observacion }}>Observación</th>
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr>
                <td colSpan={8} className="text-center">
                  No hay turnos.
                </td>
              </tr>
            ) : (
              rows.map((t) => (
                <tr key={t._id || t.id}>
                  <td
                    style={{
                      width: COLS.acciones,
                      whiteSpace: "nowrap",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        gap: 8,
                        flexWrap: "nowrap",
                        justifyContent: "center",
                      }}
                    >
                      <button
                        className="btn btn-primary"
                        onClick={() => modificaTurno(t._id || t.id)}
                      >
                        <i
                          className="fa fa-pencil-square-o"
                          aria-hidden="true"
                        />
                      </button>

                      <button
                        className="btn btn-danger"
                        onClick={() => eliminarTurno(t._id || t.id)}
                      >
                        <i className="fa fa-trash-o" aria-hidden="true" />
                      </button>
                    </div>
                  </td>

                  <td style={{ width: COLS.nro }}>
                    {t.codtur ?? "-"}
                  </td>

                  <td style={{ width: COLS.fecha }}>
                    {formatFecha(t.fechaTurno)}
                  </td>

                  <td
                    style={{
                      width: COLS.persona,
                      textAlign: "left",
                      ...cellTruncate,
                    }}
                    title={getPersonaDesc(t.persona)}
                  >
                    {getPersonaDesc(t.persona)}
                  </td>

                  <td style={{ width: COLS.atencion }}>
                    {atencionDesc(t.atencion)}
                  </td>

                  <td
                    style={{
                      width: COLS.nombre,
                      textAlign: "left",
                      ...cellTruncate,
                    }}
                    title={t.nombre || ""}
                  >
                    {t.nombre || "-"}
                  </td>

                  <td style={{ width: COLS.telefono }}>
                    {t.telefono || "-"}
                  </td>

                  <td
                    style={{
                      width: COLS.observacion,
                      textAlign: "left",
                      ...cellTruncate,
                    }}
                    title={t.observacion || ""}
                  >
                    {t.observacion || "-"}
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </div>

      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>Modificar Turno</Modal.Title>
        </Modal.Header>

        <ModalFormTurno turno={turno} handleClose={handleClose} />
      </Modal>
    </div>
  );
};

export default TableTurnos;